"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decryptScriptTags = void 0;
const decryptScriptTags = (source) => {
    if (!source) {
        return undefined;
    }
    return source
        .replace(/\[\%\{script\}\%\]/g, '<script>')
        .replace(/\[\%\{\/script\}\%\]/g, '</script>')
        .replace(/\[\%\{script /g, '<script ');
};
exports.decryptScriptTags = decryptScriptTags;
//# sourceMappingURL=decryptScriptTags.js.map